import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'

export default function Complete_projectDetails() {
    const navigate = useNavigate();
    const [companyname, setCompanyname] = useState('');
    const [listProjectMembersArray, setListProjectMembersArray] = useState([]);
    const [logedUserType, setLogedUserType] = useState([]);
    const [listProjectTaskArray, setListProjectTaskArrayy] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const active_pro_id = localStorage.getItem('selected_project_id');
    useEffect(() => {
        let comname = localStorage.getItem('mem_company_name');
        setCompanyname(comname);
        var obj = {
            pro_id: active_pro_id
        };

        console.log(obj);

        fetch('getProjectOtherdetails.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // MUST use this (since PHP returns JSON)
            .then(res => {

                if (res !== 'fail' && res.length > 0) {

                    document.getElementById('proname').innerText = res[0].pr_name;
                    document.getElementById('requr').innerText = res[0].pr_requrmenrt;
                    document.getElementById('prodesc').innerText = res[0].pr_details;
                    document.getElementById('protodo').innerText = res[0].pr_todo;
                    document.getElementById('startdate').innerText = res[0].pr_start_date;
                    document.getElementById('enddate').innerText = res[0].deadline;
                    document.getElementById('prosatus').innerText = res[0].pr_active_status;

                    getProjectMemberList();

                } else {
                    showAlert('Cannot find any details for this project.');
                }

            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
        const adminmember = localStorage.getItem('user_position');
        setLogedUserType(adminmember || 'Member');
    }, []);

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function resetlist() {
        if (logedUserType === 'Member') {
            navigate('/member_complete_projects');
        } else {
            navigate('/re_complete_procectlist');
        }

    }

    function getProjectMemberList() {
        const active_pro_id = localStorage.getItem('selected_project_id');
        var obj = {
            pro_id: active_pro_id
        };

        console.log(obj);

        fetch('getAllProjectMember.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // ✅ IMPORTANT
            .then(res => {
                getAllProjecttask();

                if (res !== 'fail' && res !== '') {
                    try {
                        var memarr = res;

                        if (Array.isArray(memarr)) {
                            var len = memarr.length;

                            if (len < 1) {
                                document.getElementById('altMesgtext').style.display = 'block';
                                document.getElementById('altMesgtext').innerText = 'No member found for this project.';
                            } else {
                                setListProjectMembersArray(memarr);
                            }
                        } else {
                            setListProjectMembersArray([]);
                            document.getElementById('altMesgtext').style.display = 'block';
                            document.getElementById('altMesgtext').innerText = 'No member found for this project.';
                        }

                    } catch (e) {
                        console.error("Invalid JSON from backend:", e);
                        setListProjectMembersArray([]);
                        document.getElementById('altMesgtext').style.display = 'block';
                        document.getElementById('altMesgtext').innerText = 'No member found for this project.';
                    }
                } else {
                    document.getElementById('altMesgtext').style.display = 'block';
                    document.getElementById('altMesgtext').innerText = 'No member found for this project.';
                    setListProjectMembersArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    function getAllProjecttask() {
        const active_pro_id = localStorage.getItem('selected_project_id');
        var obj = {
            pro_id: active_pro_id
        };
        fetch('getAllProjectTasks.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // IMPORTANT (because response can be 'fail')
            .then(result => {
                console.log(result);
                if (result !== 'fail' && result !== '') {
                    try {
                        var arr = JSON.parse(result); // convert JSON string → array
                        var len = arr.length ? arr.length : 0;
                        if (len < 1) {
                            document.getElementById('allTaskmsg').style.display = 'block';
                            document.getElementById('allTaskmsg').innerText = 'No task found for this project.';
                        } else {
                            setListProjectTaskArrayy(arr);
                        }

                    } catch (e) {
                        console.error("JSON Parse Error:", e);
                        document.getElementById('allTaskmsg').style.display = 'block';
                        document.getElementById('allTaskmsg').innerText = 'Invalid data received.';
                    }
                } else {
                    document.getElementById('allTaskmsg').style.display = 'block';
                    document.getElementById('allTaskmsg').innerText = 'No task found for this project.';
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    function reactiveProject() {
        const active_pro_id = localStorage.getItem('selected_project_id');
        var obj = {
            primary_key: active_pro_id
        };

        fetch('reactiveProject.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // IMPORTANT: text(), not json()
            .then(result => {
                if (result !== 'fail') {
                    showAlert('Project status updated successfully');
                    setTimeout(resetlist, 1500);
                } else {
                    showAlert('Cannot updated project status.');
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='topbar_menu proedittop'>
                    <h3>Project <span id="proname"></span> of {companyname} </h3>
                    <button className='member_button  proeditbtn' id="activeedit" onClick={resetlist}>Back To List</button>
                    <button className='member_button  proeditbtn nodisplay' id="inactiveedit" onClick={reactiveProject}>Re-Active Project</button>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='max-container'>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full'>
                                <h2 className='details_heading ptb-50'>General Informations</h2>
                                <div className='infoholder'>
                                    <div className='details_section'>
                                        <p className='sectionlabel'>Project Requirement: </p>
                                        <p id="requr"></p>
                                    </div>
                                    <div className='details_section'>
                                        <p className='sectionlabel'>Project Description: </p>
                                        <p id="prodesc"></p>
                                    </div>

                                    <div className='details_section'>
                                        <p className='sectionlabel'>Project Todo list: </p>
                                        <p id="protodo"></p>
                                    </div>
                                    <div className='details_section'>
                                        <p className='sectionlabel'>Project Start date: </p>
                                        <p id='startdate'></p>
                                    </div>
                                    <div className='details_section'>
                                        <p className='sectionlabel'>Project End date: </p>
                                        <p id="enddate"></p>
                                    </div>
                                    <div className='details_section'>
                                        <p className='sectionlabel'>Project Status: </p>
                                        <p id='prosatus'></p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full'>
                                <h2 className='details_heading ptb-50'>Member Informations</h2>
                                <h2 className='noticetext' id="altMesgtext"></h2>
                                <div className='infoholder'>
                                    <div className='member_row'>

                                        <div className='member_details'>
                                            <div className='vl_listing_area'>
                                                <div className='vl_listing_row'>
                                                    <div className='vl_listing_cell width25'>
                                                        <h4 className='prj_name'>Member's Name</h4>
                                                    </div>
                                                    <div className='vl_listing_cell width20'>
                                                        <p>Project Name</p>
                                                    </div>

                                                    <div className='vl_listing_cell width25'>
                                                        <p>Member Status</p>
                                                    </div>
                                                </div>
                                                {Array.isArray(listProjectMembersArray) && listProjectMembersArray.map((item, index) => {
                                                    return (
                                                        <div className='vl_listing_row'>
                                                            <div className='vl_listing_cell width25' key={index}>
                                                                <h4 className='prj_name'>{item.membername}</h4>
                                                                <input id="com_id" type="hidden" value={item.mem_com_id} />
                                                                <input id="member_main_id" type="hidden" value={item.memberid} />
                                                                <p>Member Email : {item.memberid}</p>
                                                                <input id="member_primary_key" type="hidden" value={item.primary_key} />
                                                                <input id="proid" type="hidden" value={item.proid} />
                                                                <span>Role : {item.member_role}</span>
                                                            </div>
                                                            <div className='vl_listing_cell width20'>
                                                                <p>{item.proname}</p>
                                                            </div>
                                                            <div className='vl_listing_cell width25'>
                                                                <p>{item.status_member}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full'>
                                <h2 className='details_heading ptb-50'>Task Informations</h2>
                                <h2 className='noticetext' id="allTaskmsg"></h2>
                                <div className='infoholder'>
                                    <div className='member_row'>

                                        <div className='member_details'>
                                            <section className='vl_dsh_bodypart_section pos_rel'>

                                                <div className='vl_listing_area'>
                                                    <div className='vl_listing_row'>
                                                        <div className='vl_listing_cell width15'>
                                                            <h4 className='prj_name'>Task Name</h4>
                                                        </div>
                                                        <div className='vl_listing_cell width50'>
                                                            <p>Task details</p>

                                                        </div>

                                                        <div className='vl_listing_cell width25'>
                                                            <p>Assign By</p>
                                                        </div>


                                                    </div>

                                                    {Array.isArray(listProjectTaskArray) &&
                                                        listProjectTaskArray.map((item, index) => {


                                                            return (
                                                                <div key={index} className="vl_listing_row" >
                                                                    <div className="vl_listing_cell width15">
                                                                        <h4 className="prj_name">{item.taskname}</h4>
                                                                        <input id="proj_id" type="hidden" value={item.proj_id} />
                                                                        <input id="tsk_com_id" type="hidden" value={item.tasjk_com_id} />
                                                                        <input id="tsk_primary_key" type="hidden" value={item.primary_key} />

                                                                        <span>Status: {item.tsk_status}</span>
                                                                        <span>Date: {item.assigneDate}</span>
                                                                    </div>

                                                                    <div className="vl_listing_cell width50">
                                                                        <p>{item.task_details}</p>
                                                                        <div className="inforow">
                                                                            <span>Time: {item.assign_time} hrs.</span>
                                                                            <span>Worked: {item.wordkedhours} hrs.</span>
                                                                            <span>Status: {item.tsk_status}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="vl_listing_cell width25">
                                                                        <p>{item.assigneBy}</p>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}

                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div >
    )
}
